// extracted by mini-css-extract-plugin
module.exports = {"root":"Price__root--1oYKK"};